import script from "./modern2Promo.vue?vue&type=script&lang=ts&setup=true"
export * from "./modern2Promo.vue?vue&type=script&lang=ts&setup=true"

import "./modern2Promo.vue?vue&type=style&index=0&id=726e1e23&lang=scss"

const __exports__ = script;

export default __exports__